var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "article-container" },
    _vm._l(_vm.featuredNews, function (news, index) {
      return _c("div", { key: "news-" + index, staticClass: "article" }, [
        _c(
          "a",
          {
            staticClass: "article-image-link",
            attrs: { href: _vm.articleUrl(news) },
          },
          [
            _c("img", {
              staticClass: "article-image",
              attrs: { src: news.imageUrl, alt: news.headers },
            }),
            _c("h2", { staticClass: "article-title" }, [
              _vm._v(_vm._s(news.headers)),
            ]),
          ]
        ),
        _c("p", { staticClass: "article-description" }, [
          _vm._v(_vm._s(_vm.truncatedDescription(news.description))),
        ]),
        _c(
          "a",
          {
            staticClass: "article-read-more",
            attrs: { href: _vm.articleUrl(news) },
          },
          [_vm._v(" " + _vm._s(_vm.language.wsm_ReadMore) + " > ")]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }